// MODULES
import React from "react";

// COMPONENTS
import EditableField from "@routes/Cob/components/EditableField/EditableField";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";
import NumberField from "@routes/Cob/components/NumberField/NumberField";
import QuestionField from "@routes/Cob/components/QuestionField/QuestionField";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const { props } = this;
		const { index, fields, validFields, numberLocaleFormatter, onFieldChange, onFieldBlur, onOptionsListChange } = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		})

		return (
			<div className={ classes }>
				<h3>Fonder</h3>

				<FieldsCollection
					fields={[
						{
							render: (
								<QuestionField
									Component={ NumberFieldWithName }
									name="kyc_experience_fonder_investments"
									description={
										<span>Hur många affärer i <u>Fonder</u> har du genomfört under senaste 3 åren?</span>
									}
									label="Ange antal affärer"
									value={ fields.kyc_experience_fonder_investments || "" }
									unit={ fields.kyc_experience_fonder_investments ? " st" : undefined }
									decimals={ 0 }
									valid={ validFields.kyc_experience_fonder_investments }
									customInputFormatter={ numberLocaleFormatter }
									onChange={ onFieldChange }
									onBlur={ onFieldBlur }
								/>
							),
						}, {
							render: (
								<OptionsList
									style={{ marginTop: 10 }}
									type="radio"
									orientation="horizontal"
									name="radio_kyc_knowledge_fonder"
									description="Hur stor erfarenhet har du om Fonder?"
									options={ fields.radio_kyc_knowledge_fonder.options }
									onChange={ onOptionsListChange }
								/>
							),
						},
					]}
				/>
			</div>
		);
	}
}


// PRIVATE COMPONENTS
function NumberFieldWithName(props) {
	return <EditableField { ...props } Component={ NumberField } />;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/auagfonder/Fields/collections/CollectionExperience.js